import { render } from "./SettingsLayout.vue?vue&type=template&id=30a8af14"
import script from "./SettingsLayout.vue?vue&type=script&lang=js"
export * from "./SettingsLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__